<template>
  <landing :shows-logout="true">
    <b-form
      :novalidate="true"
      :validated="true"
      @submit="candidateInfoSubmitted"
    >
      <div class="form-container">
        <h4>Συμπλήρωσε τα στοιχεία σου</h4>
        <div class="content">
          <b-form-row>
            <b-col>
              <b-form-group
                id="first-name-group"
                class="label"
                label="Όνομα"
                label-for="first-name-input"
              >
                <b-form-input
                  id="first-name-input"
                  v-model="userFirstName"
                  class="input"
                  placeholder="Όνομα"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col>
              <b-form-group
                id="last-name-group"
                class="label"
                label="Επώνυμο"
                label-for="last-name-input"
              >
                <b-form-input
                  id="last-name-input"
                  v-model="userLastName"
                  class="input"
                  placeholder="Επώνυμο"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col>
              <b-form-group
                id="email-group"
                class="label"
                label="Email"
                label-for="email-input"
              >
                <b-form-input
                  id="email-input"
                  v-model="userEmail"
                  class="input"
                  placeholder="Email"
                  type="email"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col>
              <b-form-group
                id="phone-group"
                class="label"
                label="Κινητό Τηλέφωνο"
                label-for="phone-input"
              >
                <b-form-input
                  id="phone-input"
                  v-model="userPhone"
                  class="input"
                  placeholder="Κινητό"
                  type="tel"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col>
              <b-form-group
                id="phone-group"
                class="label"
                label="Πόλη"
                label-for="city-input"
                :invalid-feedback="errorMessage"
              >
                <b-spinner v-if="isLoading" small></b-spinner>
                <b-form-select
                  v-else
                  id="city-input"
                  v-model="workingCity"
                  class="input"
                  :options="cities"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col>
              <b-form-group
                class="label"
                label="Τμήμα"
                label-for="department-input"
              >
                <b-form-radio-group
                  id="department-input"
                  v-model="department"
                  class="input"
                  :options="departments"
                  :disabled="isDepartmentCompleted"
                  required
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col>
              <b-form-group
                class="label"
                label="Τύπος"
                label-for="slmType-input"
              >
                <b-form-radio-group
                  id="slmType-input"
                  v-model="slmType"
                  class="input"
                  :options="slmTypes"
                  :disabled="isSlmTypeCompleted"
                  required
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-form-row>
        </div>

        <div class="footer-form">
          <b-button
            type="submit"
            variant="primary"
            :disabled="!isEmployeeCompleted"
            >{{ $t('interviewPage.info.submitButton') }}</b-button
          >
        </div>
      </div>
    </b-form>
  </landing>
</template>

<script>
import { mapGetters } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/analytics';
import Landing from '@/components/Landing.vue';
import { requester } from '../helpers/requester';

export default {
  name: 'UserDetails',
  components: { Landing },
  data() {
    return {
      cities: [],
      slmTypes: [
        { text: 'SLM Core', value: 'core' },
        { text: 'SLM Extra', value: 'extra' }
      ],
      departments: [
        { text: 'Drivers', value: 'drivers' },
        { text: 'Warehouse', value: 'warehouse' }
      ],
      isLoading: true,
      errorMessage: ''
    };
  },
  computed: {
    ...mapGetters(['isEmployeeCompleted']),
    ...mapGetters(['isSlmTypeCompleted']),
    ...mapGetters(['isDepartmentCompleted']),
    ...mapGetters(['isWarehouse']),
    userFirstName: {
      get() {
        return this.$store.getters.userInfo.first_name;
      },
      set(newValue) {
        this.$store.commit('setUserFirstName', newValue);
      }
    },
    userLastName: {
      get() {
        return this.$store.getters.userInfo.last_name;
      },
      set(newValue) {
        this.$store.commit('setUserLastName', newValue);
      }
    },
    userEmail: {
      get() {
        return this.$store.getters.userInfo.email;
      },
      set(newValue) {
        this.$store.commit('setUserEmail', newValue);
      }
    },
    userPhone: {
      get() {
        return this.$store.getters.userInfo.phone;
      },
      set(newValue) {
        this.$store.commit('setUserPhone', newValue);
      }
    },
    workingCity: {
      get() {
        return this.$store.getters.workingCity?.id;
      },
      set(newValue) {
        this.$store.commit('setWorkingCity', newValue);
      }
    },
    slmType: {
      get() {
        return this.$store.getters.slmType;
      },
      set(newValue) {
        this.$store.commit('setSelectedSlmType', newValue);
      }
    },
    department: {
      get() {
        return this.$store.getters.department;
      },
      set(newValue) {
        this.$store.commit('setSelectedDepartment', newValue);
      }
    }
  },
  mounted() {
    this.getCities();
  },
  methods: {
    async getCities() {
      const req = await requester();

      req
        .get('/cities')
        .then(res => {
          this.cities = res.data.cities.map(city => ({
            text: city.name,
            value: city.id
          }));
          this.isLoading = false;
        })
        .catch(res => {
          if (res.message != null) {
            console.log(res);
            this.errorMessage = res.message;
          } else {
            this.errorMessage = 'Could not fetch cities.';
          }
          this.isLoading = false;
        });
    },
    async candidateInfoSubmitted(event) {
      window.fbq('track', 'SubmitApplication');
      firebase.analytics().logEvent('submit_application');
      event.preventDefault();

      try {
        await this.$store.dispatch('editEmployee');

        this.$router.push({ name: 'Interview' });
      } catch (error) {
        this.$bvToast.toast(
          'Παρουσιάστηκε κάποιο σφάλμα. Παρακαλούμε προσπαθήστε ξανά.',
          {
            title: 'Σφάλμα',
            toaster: 'b-toaster-bottom-full',
            variant: 'danger',
            autoHideDelay: 3000
          }
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/elements.scss';

$orange: #f68b24;
$orange9: rgba(246, 139, 36, 0.9);

.content {
  margin: 1rem 0;
  padding: 0 2rem;

  p {
    font-weight: 200;
    text-align: center;
  }

  .label {
    color: $orange;
  }
  .input {
    border-color: $orange !important;
    max-width: 300px;
  }
}
.footer-form {
  border-top: 1px solid $orange9;
  padding: 1rem 2rem;
  display: flex;
  justify-content: flex-end;
}
</style>
